import { Component, OnInit } from '@angular/core';
import { Field } from '../../field';
import { LayoutService } from '../../layout.service';

@Component({
  selector: 'app-input-address',
  templateUrl: './input-address.component.html',
  styleUrls: ['./input-address.component.less']
})
export class InputAddressComponent extends Field {
  constructor(public layoutService: LayoutService) {
    super(layoutService);
  }
}
